export enum UpgradeError {
  none = 'noError',
  httpError = 'httpError',
  notAvailable = 'notAvailable',
  alreadyUpgraded = 'alreadyUpgraded',
  inProgress = 'inProgress',
  upgradeClosed = 'upgradeClosed',
  notFinnair = 'notFinnair',
  notLoggedIn = 'notLoggedIn',
  insufficientPayment = 'insufficientPayment',
  notPossible = 'notPossible',
  notAvailableAccount = 'notAvailableAccount',
  waitlistOnly = 'waitlistOnly',
  noRemainingUpgrades = 'noRemainingUpgrades',
  paymentError = 'paymentError',
  maintenance = 'maintenance',
}

export enum InvalidUpgradeError {
  invalidBookingRef = 'Invalid booking reference',
  infant = 'Booking has infant',
  paxCount = 'Booking has too many passengers, upgrade not supported',
  group = 'Booking is group booking, upgrade not supported',
  invalidSSR = 'Booking has invalid SSR, upgrade not supported',
}
